import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodos() {
        return axiosJwt.get(`${api}/admin/controleacesso/perfisacesso`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterPorId(id) {
        return axiosJwt.get(`${api}/admin/controleacesso/perfisacesso/${id}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    inserirPerfilAcesso(perfilAcesso) {
        return axiosJwt.post(`${api}/admin/controleacesso/perfisacesso`, perfilAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarPerfilAcesso(perfilAcesso) {
        return axiosJwt.put(`${api}/admin/controleacesso/perfisacesso`, perfilAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    associarRegrasAcesso(perfilRegrasAcesso) {
        return axiosJwt.post(`${api}/admin/controleacesso/perfisacesso/${perfilRegrasAcesso.perfilAcessoId}/regrasacesso`, perfilRegrasAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarRegraAcesso(perfilRegraAcesso) {
        return axiosJwt.patch(`${api}/admin/controleacesso/perfisacesso/${perfilRegraAcesso.perfilAcessoId}/regraacesso`, perfilRegraAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    desassociarRegrasAcesso(perfilRegrasAcesso) {
        return axiosJwt.patch(`${api}/admin/controleacesso/perfisacesso/${perfilRegrasAcesso.perfilAcessoId}/regrasacesso`, perfilRegrasAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarPerfilRegraAcesso(perfilRegraAcesso) {
        return axiosJwt.put(`${api}/admin/controleacesso/perfisacesso/${perfilRegraAcesso.perfilAcessoId}/regraacesso`, perfilRegraAcesso)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    clonarPerfilAcesso(perfilAcessoId) {
        return axiosJwt.post(`${api}/admin/controleacesso/perfisacesso/${perfilAcessoId}/clonar`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }

}
